import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import React, { FC, memo } from 'react';
import useUserInfo from 'src/hooks/user/use-user-info';
import { slices, useAppSelector } from 'src/redux';
import { formatCurrency } from 'src/utils';

const { selectors: purchaseOrderSelectors } = slices.purchaseOrder;

const PoSummary: FC = () => {
  const { isAccountingStaff } = useUserInfo();

  const totalAmount = useAppSelector(purchaseOrderSelectors.selectTotalAmount);

  return isAccountingStaff && totalAmount !== null ? (
    <Card>
      <CardContent>
        <Grid container spacing={8} alignItems="center" justify="center">
          <Grid item>
            <div
              style={{
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Typography variant="h5" color="textSecondary">
                Total Amount
              </Typography>
              <Typography variant="h4" color="primary">
                {formatCurrency(totalAmount)
                  ? formatCurrency(totalAmount)
                  : '₱0.00'}
              </Typography>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  ) : null;
};

export default memo(PoSummary);
